// extracted by mini-css-extract-plugin
export default {"container":"fXKqR","textWrapper":"Z-KJh","title":"Ba4PT","description":"WhBn1","labelWrapper":"FnJ-3","actionWrapper":"Zuwnn","skeleton-progress":"HedZr"};